export default class Passenger {
  name = '';
  email = '';
  phoneCountryCode = '886';
  phoneNumber = '';
  // identityNumber = ""

  constructor({
    name = '',
    email = '',
    phoneCountryCode = '886',
    phoneNumber = '',
    identityNumber = '',
  } = {}) {
    this.name = name;
    this.email = email;
    this.phoneCountryCode = phoneCountryCode;
    this.phoneNumber = phoneNumber;
    // this.identityNumber = identityNumber
  }

  get isEmpty() {
    return !this.name && !this.email && !this.phoneNumber; // && !this.identityNumber
  }

  get isValid() {
    return Boolean(this.name && this.email && this.phoneNumber); //&& this.identityNumber)
  }

  clone() {
    return new Passenger({
      name: this.name,
      email: this.email,
      phoneCountryCode: this.phoneCountryCode,
      phoneNumber: this.phoneNumber,
      // identityNumber: this.identityNumber,
    });
  }
}
